import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import AppRouter from './Router';
import Notification from './modules/app/components/Notification.component';
import * as AppActions from './state/actions/creators/app.actioncreator';
import CacheBuster from './modules/app/components/CacheBuster';
import packageJson from '../package.json';

class App extends PureComponent {
  componentDidMount() {
    const {
      token, setOfflineAction, setOnlineAction,
    } = this.props;

    localStorage.setItem('token', token);

    window.addEventListener('online', () => {
      setOnlineAction();
    });

    window.addEventListener('offline', () => {
      setOfflineAction();
    });
    document.title = `QualitasApp - ${packageJson.version}`;
  }

  render() {
    const { history, token } = this.props;
    const authenticated = typeof token !== 'undefined' && token;
    return (
      <div>
        <CacheBuster>
          {({ loading, isLatestVersion, refreshCacheAndReload }) => {
            if (loading) return <div>Cargando</div>;
            if (!loading && !isLatestVersion) {
              refreshCacheAndReload();
            }

            return (
              <div>
                <Notification />
                <AppRouter history={history} authenticated={authenticated} />
              </div>
            );
          }}
        </CacheBuster>
      </div>
    );
  }
}

/* eslint react/forbid-prop-types: 0 */
App.propTypes = {
  token: PropTypes.string,
  history: PropTypes.object.isRequired,
  setOfflineAction: PropTypes.func.isRequired,
  setOnlineAction: PropTypes.func.isRequired,
};


function mapStateToProps({
  auth, navigation,
}) {
  return {
    token: auth.token,
    navigation,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...AppActions,
    }, dispatch,
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(App);
